export default class SubscriberFormEmailCtrl {
    constructor($scope, $filter, $rootScope, $stateParams, $state, $q, SideMenu, Rest, Tag, Setting, Segment, Events, SweetAlert, SubscriberForm) {
        SideMenu.setActive('subscriber');

        this._translator = $filter('translate');
        this._rootScope = $rootScope;
        this._stateParams = $stateParams;
        this._state = $state;
        this._q = $q;
        this._scope = $scope;

        this.rest = Rest.rest;
        this.settingsRepo = Setting;
        this.subscriberFormRepo = SubscriberForm;
        this.alerter = SweetAlert;
        this.eventHandler = Events;

        this.dispatcherType = 'subscriberForm';
        this.status = 'email';

        Segment.all().then((segments) => {
            this.activeSegments = segments.data;
            this._scope.$broadcast('mailEditor:segments:fetched', this.activeSegments);
        });

        Tag.all().then((tags) => {
            this.activeTags = tags.data;
            this._scope.$broadcast('mailEditor:tags:fetched', this.activeTags);
        });

        this.preview = {
            to: null
        };

        this.dispatcher = {
            email: {
                id: null,
                from_name: '',
                from_email: '',
                subject: '',
                email_template_id: 0,
                language: null,
                ga_utm_campaign: ''
            },
            subscriber_form_id: this._stateParams.id
        };


        if (this._stateParams.emailId) {
            this.loadingDispatcher = true;
            this.templateSelected = true;

            this.subscriberFormRepo.find(this._stateParams.id, [ 'email' ]).then((response) => {
                this.subscriberForm = response.data; // To enable the top folders..
                this.dispatcher = response.data;
                this.dispatcher.id = response.data.id;
                this.dispatcher.email = response.data.email;
                this.htmlSource = "subscriber-form/" + this._stateParams.id + "/email/htmlContent";
                this.plainSource = "subscriber-form/" + this._stateParams.id + "/email/plainContent";
                this.updatePlainContent("subscriber-form/" + this._stateParams.id + "/email/plainContent");
                this.loadingDispatcher = false;

                this._rootScope.$broadcast('mailEditor:state:init', {
                    dispatcher: this.dispatcher,
                    dispatcherType: 'subscriberForm',
                    htmlSource: this.htmlSource,
                    plainSource: this.plainSource,
                    templateId: this.dispatcher.email.email_template_id
                });
            });
        } else {
            this.htmlSource = null;
            this.templateSelected = null;
            this.dispatcher.id = this._stateParams.id;

            this.settingsRepo.findSenderDetail().then((details) => {
                this.dispatcher.email.from_name = details.company || details.name;
                this.dispatcher.email.from_email = details.email;
                this._rootScope.$broadcast('mailEditor:templateSelector:show');
            });
        }

        this._scope.$on('mailEditor:template:selected', (event, templateId) => {
            this.dispatcher.email.email_template_id = templateId;
            this.htmlSource = 'template/' + templateId + '/htmlContent';
            this.updatePlainContent('template/' + templateId + '/plainContent');
            this._scope.$broadcast('mailEditor:state:init', {
                dispatcher: this.dispatcher,
                dispatcherType: 'subscriberForm',
                htmlSource: 'template/' + templateId + '/htmlContent',
                plainSource: 'template/' + templateId + '/plainContent',
                templateId: this.dispatcher.email.email_template_id
            });
            this.templateSelected = true;
        });

        this._scope.$on('mailEditor:template:notChanged', () => {
            this.templateSelected = true;
        });

        this._scope.$on('subscriberForm:goTo', (event, toState) => {
            return this.goTo(toState);
        });

        this._scope.$on('account:changed', () => {
            this._state.go('subscriberForm.index');
        });
    }

    redirect(page) {
        switch (page) {
            case 'builder':
                this._state.go('subscriberForm.edit', { id: this._stateParams.id });
                break;
            case 'settings':
                this._state.go('subscriberForm.settings', { id: this._stateParams.id });
                break;
            default:
                this._state.go('subscriberForm.' + page, { id: this._stateParams.id });
        }
    }

    openImageBank() {
        this._scope.$emit('imageBank:toggle');
    }

    goTo(page) {
        if (this.htmlSource) {
            this.save(true).then(() => {
                this.redirect(page);
            });
        } else {
            this.redirect(page);
        }
    };

    updatePlainContent(src) {
        this.rest.one(src).get().then((content) => {
            this.plainContent = content;
        });
    };

    newTemplate() {
        this.templateSelected = null;
        this._scope.$broadcast('mailEditor:templateSelector:show');
    };

    validSender() {
        return this.dispatcher.email.from_name.length > 0 && this.dispatcher.email.from_email;
    };

    validSubject() {
        return this.dispatcher.email.subject.length > 0
    };

    validPreview() {
        var returnArray = [];

        if (! this.preview.to) {
            returnArray.push(this._translator('CAMPAIGN:FLASH:PREVIEW_RECIPENT_ERROR'));
        } if (! this.validSender()) {
            returnArray.push(this._translator('CAMPAIGN:FLASH:INVALID_SENDER'));
        } if (! this.validSubject()) {
            returnArray.push(this._translator('CAMPAIGN:FLASH:INVALID_SUBJECT'));
        }

        return returnArray;
    };

    sendPreview() {

        if (this.validPreview().length > 0) {
            let message = '';

            angular.forEach(this.validPreview(), (value) => {
                message += value + '\n';
            });

            return this.alerter.swal({
                title: 'Error',
                text: message,
                type: 'error'
            });
        }

        this.save().then(() => {
            this.rest.all('email').all('preview').post({
                email_id: this.dispatcher.email.id,
                preview_to: this.preview.to
            }).then(() => {
                this.eventHandler.flashEvent('notification', this._translator('CAMPAIGN:FLASH:PREVIEW'))
            }, (error) => {
                let msg = error.status == 400 ? 'CAMPAIGN:FLASH:PREVIEW_RECIPENT_FORMAT_ERROR' : 'CAMPAIGN:FLASH:PREVIEW_ERROR';
                this.alerter.swal({
                    title: 'Error',
                    text: this._translator(msg),
                    type: 'error'
                });
            })
        })
    };

    validTfs() {
        return this.validSender() && this.validSubject()
    };

    validOptInTag() {
        return this.dispatcher.email.html_content.indexOf('%Link:Optin%') > -1;
    };

    save(next = false) {
        let createSubscriberFormEmail = (deferred) => {
            this.rest.all('subscriber-form/' + this._stateParams.id + '/email').post(this.dispatcher).then((response) => {
                this.dispatcher.email = response.data;
                this.eventHandler.flashEvent('notification', this._translator('AUTOMATION:FLASH:CREATED'));

                if (!next) {
                    this._state.go('subscriberForm.email.edit', {
                        id: this._stateParams.id,
                        emailId: this.dispatcher.email.id
                    });
                }

                deferred.resolve();
            }, (error) => {
                if (error.status == 400) {
                    if (error.data.validationError['email.plain_content']) {
                        this.eventHandler.flashEvent('error', this._translator('CAMPAIGN:SUMMARY:PLAIN_CONTENT_ERROR'));
                    } else {
                        this.eventHandler.flashEvent('error', this._translator('CAMPAIGN:SUMMARY:SENDER_ERROR'));
                    }
                    deferred.reject();
                }
            });
        };

        let updateSubscriberFormEmail = (deferred) => {
            this.subscriberFormRepo.saveEmail(this._stateParams.id, this.dispatcher.email).then(() => {
                this.eventHandler.flashEvent('notification', this._translator('AUTOMATION:FLASH:SAVED'));
                this._rootScope.$broadcast('dispatcher:updated');
                deferred.resolve();
            }, (error) => {
                if (error.status == 400) {
                    if (error.data.validationError['email.plain_content']) {
                        this.eventHandler.flashEvent('error', this._translator('CAMPAIGN:SUMMARY:PLAIN_CONTENT_ERROR'));
                    } else {
                        this.eventHandler.flashEvent('error', this._translator('CAMPAIGN:SUMMARY:SENDER_ERROR'));
                    }
                    deferred.reject();
                }
            });
        };

        var deferred = this._q.defer();

        if (! this.validTfs()) {
            this.eventHandler.flashEvent('error', this._translator('CAMPAIGN:FLASH:UPDATE_ERROR'));
            deferred.reject();

            return deferred.promise;
        }

        this._rootScope.$broadcast('settings:applyHTMLSettings');

        this._rootScope.$broadcast('template:updateHtml', (htmlContent) => {

            this._scope.$broadcast('plainEditor:getContent', (plainContent) => {
                this.dispatcher.email.html_content = htmlContent;
                this.dispatcher.email.plain_content = plainContent;

                if (! this.validOptInTag()) {

                    this.alerter.swal({
                        title: this._translator('CAMPAIGN:FLASH:OPTIN_LINK_MISSING_TITLE'),
                        text: this._translator('CAMPAIGN:FLASH:OPTIN_LINK_MISSING'),
                        type: 'error'
                    });

                    deferred.reject();
                    return deferred.promise;
                }

                if (this.dispatcher.email.id === null) {
                    createSubscriberFormEmail(deferred);
                } else {
                    updateSubscriberFormEmail(deferred);
                }
            });

        });

        return deferred.promise;
    }
};
